// @ts-nocheck
import React from 'react';
import { flexRender, type Row } from '@tanstack/react-table';
import type { AdminUser } from '../../types/admin';
import { useSwipeGesture } from './useSwipeGesture';

interface AdminTableRowProps {
  row: Row<AdminUser>;
  selectedRows: string[];
  onSelect: (userId: string, selected: boolean) => void;
}

export const AdminTableRow: React.FC<AdminTableRowProps> = ({
  row,
  selectedRows,
  onSelect,
}) => {
  const user = row.original;
  const isSelected = selectedRows.includes(user.id);

  const swipeGesture = useSwipeGesture({
    onSwipeLeft: () => {
      if (!isSelected) {
        onSelect(user.id, true);
      }
    },
    onSwipeRight: () => {
      if (isSelected) {
        onSelect(user.id, false);
      }
    },
    threshold: 50,
  });

  return (
    <tr
      className="border-t border-luna-secondary/10 hover:bg-luna-secondary/5 relative"
      role="row"
      {...swipeGesture}
    >
      {row.getVisibleCells().map((cell) => (
        <td
          key={cell.id}
          className="px-3 sm:px-4 py-3 text-xs sm:text-sm text-luna-text-light dark:text-luna-text-dark"
          style={{ width: cell.column.getSize() }}
        >
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </td>
      ))}
    </tr>
  );
};

